/**
 * Uma trilha no índice de formulários.
 *
 * O cartão responde três perguntas na ordem em que o cliente as faz: o que é isto, por que
 * apareceu para mim, e em que pé está. A segunda é a que o formulário atual nunca respondeu —
 * quem recebe um link de kickoff hoje não sabe por que aquele módulo está ali —, e a resposta
 * vem pronta do servidor em `origem`.
 */

import { Link } from "react-router";
import { Cartao, Chip } from "../ui";
import { BarraDeProgresso } from "./BarraDeProgresso";
import {
  CHIP_DO_ESTADO,
  ROTULO_DO_ESTADO,
  acaoDaTrilha,
  caminhoDaTrilha,
  type TrilhaDaImplantacao,
} from "../../nucleo/kickoff";

export function CartaoDaTrilha({ trilha }: { trilha: TrilhaDaImplantacao }) {
  const estado = trilha.sessao.estado;

  return (
    /* O invólucro carrega a identidade da trilha — chave e estado. O estado vai como atributo,
       e não só como cor do chip: cor sozinha não serve nem para quem não a enxerga nem para o
       teste automatizado. */
    <div
      className="trilha-na-lista"
      data-testid={`trilha-${trilha.chave}`}
      data-chave={trilha.chave}
      data-estado={estado}
    >
      <Cartao
        className="cartao-da-trilha"
        titulo={trilha.nome}
        acessorio={
          <Chip estado={CHIP_DO_ESTADO[estado]}>{ROTULO_DO_ESTADO[estado]}</Chip>
        }
      >
        {estado === "enviada" ? <p className="trilha-na-lista__concluida">Sua parte: concluída</p> : null}
        <p className="cartao__texto">{trilha.origem}</p>

        <BarraDeProgresso progresso={trilha.progresso} compacta />

        <dl className="cartao-da-trilha__dados">
          <div>
            <dt className="campo__rotulo">Responsável</dt>
            <dd className="m-0 text-xs">
              {trilha.sessao.responsavel?.nome ?? "ainda ninguém abriu"}
            </dd>
          </div>
          <div>
            <dt className="campo__rotulo">Versão do formulário</dt>
            {/* A versão fica à vista porque duas versões do Força de Vendas circularam em
                paralelo em 2026: saber qual foi respondida é o que torna a resposta comparável. */}
            <dd className="m-0 text-xs numero-tabular">v{trilha.versao}</dd>
          </div>
        </dl>

        <Link
          to={caminhoDaTrilha(trilha.chave)}
          className="botao botao--pequeno"
          data-testid={`abrir-${trilha.chave}`}
        >
          {acaoDaTrilha(trilha)}
        </Link>
      </Cartao>
    </div>
  );
}
